import CGU_TR from "./cguTranslations.json";

// Texte de référence des Conditions Générales d'Utilisation (version française — établie en juillet 2026).
// Version de référence en cas de divergence d'interprétation (cf. Article 55).

export const CGU_TITLE = "CONDITIONS GÉNÉRALES D'UTILISATION";

export const CGU_SUBTITLE = "BOUGIEDUCŒUR / POSTINITY";
export const CGU_FOOTER = "CONDITIONS GÉNÉRALES D'UTILISATION ÉTABLIES EN JUILLET 2026";

export const CGU_INTRO = `Les présentes Conditions Générales d'Utilisation, ci-après les « CGU », ont pour objet de définir les conditions d'accès et d'utilisation du site bougieducoeur.com, de sa version installable sous forme de Progressive Web App (PWA), ainsi que des services BougieDuCœur et Postinity – De mon vivant.
BougieDuCœur est une plateforme numérique consacrée au souvenir, à la mémoire et à la transmission.
La création d'un compte, l'utilisation des services réservés aux membres ou la souscription à une offre impliquent l'acceptation des présentes CGU.`;

export const CGU_ARTICLES = [
  {
    t: "ARTICLE 1 — ÉDITEUR ET EXPLOITANT DU SERVICE",
    p: `Le site, la Progressive Web App ainsi que les services BougieDuCœur et Postinity sont édités et exploités par :
ECO EVENT SARL
78 avenue des Champs-Élysées
75008 Paris
France
SIREN : 799 853 148
E-mail : contact@bougieducoeur.com
Ci-après dénommée « ECO EVENT », « BougieDuCœur », « Postinity », « la Plateforme » ou « l'Éditeur ».
ECO EVENT SARL assure l'exploitation technique, commerciale et administrative des services proposés.`,
  },
  {
    t: "ARTICLE 2 — PRÉSENTATION GÉNÉRALE",
    p: `La Plateforme comprend principalement deux univers complémentaires :

BougieDuCœur
BougieDuCœur permet de rendre hommage à une personne décédée par la création d'un mémorial numérique et notamment :
• d'allumer une bougie virtuelle ;
• de créer un mémorial ;
• de publier une photographie ;
• de rédiger un hommage ;
• de recueillir des messages de condoléances ;
• de partager des souvenirs ;
• de créer des groupes familiaux ;
• de partager le mémorial avec des proches ;
• de consulter des récits et contenus consacrés à la mémoire et au souvenir.

Postinity – « De mon vivant »
Postinity permet à une personne de préparer, de son vivant, différents contenus qu'elle souhaite conserver et éventuellement transmettre après son décès.
Ces contenus peuvent notamment comprendre :
• sa propre bougie ;
• des photographies ;
• des vidéos ;
• des fichiers audio ;
• des musiques ;
• des documents ;
• des citations ;
• un dossier destiné à une cérémonie ;
• des messages personnels destinés à des proches identifiés.`,
  },
  {
    t: "ARTICLE 3 — NATURE DE POSTINITY",
    p: `Postinity est un service numérique de conservation, d'organisation et de transmission conditionnelle de contenus.
Postinity ne constitue notamment :
• ni un testament ;
• ni un testament authentique ;
• ni un acte notarié ;
• ni un service de notaire ;
• ni un service funéraire ;
• ni un contrat d'assurance décès ;
• ni un mandat de protection future ;
• ni un service de séquestre notarial.
Les contenus déposés sur Postinity n'ont vocation à produire que les effets associés au fonctionnement contractuel de la Plateforme.
Lorsqu'un utilisateur souhaite donner une portée successorale ou testamentaire à certaines volontés, il lui appartient d'utiliser parallèlement les dispositifs juridiques appropriés.`,
  },
  {
    t: "ARTICLE 4 — CONDITIONS D'ACCÈS",
    p: `Les parties publiques de BougieDuCœur peuvent être consultées sans création de compte.
Certaines fonctionnalités nécessitent un compte utilisateur.
Les fonctionnalités Postinity « De mon vivant » sont réservées aux personnes :
• âgées de 18 ans ou plus ;
• disposant de la capacité juridique nécessaire ;
• utilisant le service en leur nom propre.
La Plateforme peut demander des éléments complémentaires lorsqu'une vérification d'identité ou de situation est nécessaire.`,
  },
  {
    t: "ARTICLE 5 — CRÉATION DU COMPTE",
    p: `La création d'un compte peut notamment nécessiter :
• prénom ;
• nom ;
• adresse électronique ;
• mot de passe ;
• pays ;
• indicatif téléphonique ;
• numéro de téléphone lorsqu'il est demandé ;
• langue préférée ;
• préférences de notifications ;
• photographie de profil facultative ;
• acceptation des conditions applicables.
L'utilisateur garantit que les informations fournies sont exactes, sincères et à jour.
L'adresse électronique constitue l'un des principaux identifiants du compte.`,
  },
  {
    t: "ARTICLE 6 — SÉCURITÉ DU COMPTE",
    p: `L'utilisateur est responsable de la confidentialité de ses identifiants.
Il doit prendre toutes les précautions raisonnables nécessaires pour empêcher l'accès de tiers à son compte.
En cas de suspicion d'utilisation frauduleuse, il doit en informer rapidement la Plateforme à : contact@bougieducoeur.com
La Plateforme peut mettre en œuvre notamment :
• confirmation de l'adresse électronique ;
• codes temporaires ;
• authentification renforcée ;
• limitation des tentatives ;
• journalisation des connexions ;
• contrôle des accès inhabituels.`,
  },
  {
    t: "ARTICLE 7 — FONCTIONNALITÉS ACCESSIBLES AUX VISITEURS",
    p: `Selon les paramètres du mémorial concerné, un visiteur peut notamment :
• consulter un mémorial ;
• consulter l'histoire d'un défunt ;
• allumer gratuitement une bougie ;
• déposer un message de condoléances ;
• indiquer son nom ;
• ajouter une photographie lorsque cette possibilité est proposée ;
• réagir à un message ;
• consulter le blog ;
• partager un mémorial ;
• utiliser un lien, un QR code, un code court ou une adresse personnalisée.
Tout visiteur publiant un contenu est responsable de celui-ci.`,
  },
  {
    t: "ARTICLE 8 — FONCTIONNALITÉS DES MEMBRES",
    p: `Un membre connecté peut notamment :
• créer une bougie ou un mémorial ;
• renseigner l'identité du défunt ;
• ajouter des dates de naissance et de décès ;
• ajouter une photographie ;
• indiquer une nationalité ;
• rédiger un hommage ;
• choisir une durée d'affichage ;
• modifier ses contenus ;
• prolonger une bougie ;
• rallumer une bougie lorsque cette fonction est disponible ;
• réorganiser ses mémoriaux ;
• créer ou rejoindre un groupe familial ;
• inviter des proches ;
• recevoir des notifications ;
• utiliser les outils de parrainage ;
• bénéficier d'éventuels avantages Ambassadeur ;
• gérer son profil ;
• supprimer certains contenus.`,
  },
  {
    t: "ARTICLE 9 — GROUPES FAMILIAUX",
    p: `La Plateforme peut permettre à plusieurs personnes de contribuer collectivement à un mémorial.
Le responsable ou créateur d'un groupe peut notamment :
• inviter des proches ;
• gérer les participants ;
• recueillir des textes ;
• recueillir des photographies ;
• organiser les contributions ;
• suivre l'activité du groupe.
Chaque participant demeure personnellement responsable des contenus qu'il publie.
La création ou l'administration d'un groupe ne confère aucune qualité particulière d'héritier ou d'ayant droit.`,
  },
  {
    t: "ARTICLE 10 — CONTENUS DES UTILISATEURS",
    p: `Les utilisateurs peuvent être autorisés à déposer notamment :
• textes ;
• photographies ;
• vidéos ;
• enregistrements audio ;
• fichiers musicaux ;
• documents ;
• messages de condoléances ;
• contributions familiales ;
• messages privés Postinity.
L'utilisateur conserve les droits qu'il détient sur les contenus qu'il publie.
Pour permettre le fonctionnement du service, il accorde à ECO EVENT SARL une autorisation non exclusive permettant, strictement dans le cadre du service :
• l'hébergement ;
• le stockage ;
• la sauvegarde ;
• la reproduction technique ;
• l'adaptation aux différents formats d'affichage ;
• l'affichage ;
• la mise à disposition ;
• la transmission aux personnes autorisées.
Cette autorisation est consentie pour la durée nécessaire au fonctionnement du service et à l'exécution des prestations demandées.`,
  },
  {
    t: "ARTICLE 11 — RESPONSABILITÉ SUR LES CONTENUS",
    p: `L'utilisateur garantit qu'il dispose des droits nécessaires sur les contenus qu'il transmet.
Il lui appartient notamment de vérifier :
• ses droits sur les photographies ;
• ses droits sur les vidéos ;
• ses droits sur les musiques ;
• ses droits sur les textes et documents ;
• le respect de la vie privée des personnes vivantes ;
• le respect du droit à l'image ;
• le respect de la mémoire et de la dignité des personnes décédées.
L'utilisateur ne doit pas publier un contenu appartenant à un tiers sans autorisation lorsqu'une telle autorisation est nécessaire.`,
  },
  {
    t: "ARTICLE 12 — CONTENUS INTERDITS",
    p: `Sont notamment interdits :
• les contenus illicites ;
• les contenus frauduleux ;
• les faux mémoriaux ;
• les fausses déclarations de décès ;
• les usurpations d'identité ;
• les contenus diffamatoires ;
• les contenus injurieux ;
• les contenus haineux ;
• les contenus discriminatoires ;
• les menaces ;
• le harcèlement ;
• les atteintes graves à la dignité ;
• les atteintes illicites à la vie privée ;
• les violations de droits d'auteur ;
• l'utilisation frauduleuse de photographies ;
• l'utilisation du service dans le but de nuire à une famille ou à un tiers ;
• les logiciels ou fichiers malveillants.`,
  },
  {
    t: "ARTICLE 13 — MODÉRATION",
    p: `ECO EVENT SARL peut intervenir sur un contenu lorsqu'elle dispose d'éléments lui permettant de considérer qu'il est contraire :
• aux présentes CGU ;
• à la loi ;
• aux droits d'un tiers ;
• à la vocation mémorielle du service.
Selon les circonstances, elle peut :
• demander des explications ;
• masquer temporairement un contenu ;
• limiter sa visibilité ;
• demander un justificatif ;
• supprimer un contenu ;
• suspendre une fonctionnalité ;
• suspendre un compte ;
• fermer un compte dans les situations les plus graves.`,
  },
  {
    t: "ARTICLE 14 — SIGNALEMENT",
    p: `Tout contenu litigieux peut être signalé à : contact@bougieducoeur.com
Le demandeur doit permettre d'identifier précisément :
• le contenu concerné ;
• sa localisation ;
• le motif de la demande ;
• le droit éventuellement invoqué.
La Plateforme peut demander des justificatifs complémentaires avant de prendre une décision.`,
  },
  {
    t: "ARTICLE 15 — MÉMOIRE ET DIGNITÉ DU DÉFUNT",
    p: `La vocation de BougieDuCœur est de permettre des hommages respectueux.
Les utilisateurs s'engagent à respecter :
• la mémoire du défunt ;
• sa dignité ;
• les droits de sa famille ;
• les droits des tiers ;
• les droits attachés aux photographies et œuvres utilisées.
En présence d'un conflit familial sérieux, la Plateforme peut suspendre temporairement tout ou partie du mémorial pendant l'étude du différend.
ECO EVENT SARL n'a pas vocation à se substituer à une juridiction pour déterminer une qualité d'héritier ou trancher un litige successoral.`,
  },
  {
    t: "ARTICLE 16 — POSTINITY « DE MON VIVANT »",
    p: `L'utilisateur Postinity peut préparer de son vivant les contenus qu'il souhaite éventuellement voir transmis après son décès.
Ces éléments peuvent être modifiés ou supprimés par l'utilisateur tant que les fonctionnalités correspondantes restent accessibles et qu'aucune transmission posthume n'a été déclenchée.
L'utilisateur reste seul responsable :
• du choix de ses messages ;
• du choix de ses destinataires ;
• de l'exactitude de leurs coordonnées ;
• du choix des Garants ;
• des documents déposés ;
• de ses instructions.`,
  },
  {
    t: "ARTICLE 17 — DIRECTIVES APRÈS DÉCÈS",
    p: `Lorsque l'utilisateur souhaite définir des directives particulières concernant la conservation, l'effacement ou la communication de ses données après son décès, ces directives font l'objet d'un mécanisme spécifique.
Le consentement à ces directives est distinct de la seule acceptation des présentes CGU.
L'utilisateur peut les modifier ou les révoquer tant qu'il est vivant et que son compte lui est accessible.
La Plateforme exécute ces instructions dans les limites :
• de la loi ;
• des droits des tiers ;
• des droits des destinataires ;
• des possibilités techniques du service.`,
  },
  {
    t: "ARTICLE 18 — LES GARANTS",
    p: `L'utilisateur peut désigner jusqu'à trois Garants.
Un Garant est une personne de confiance désignée par l'utilisateur.
Les Garants reçoivent une invitation.
Le Garant peut accepter ou refuser cette fonction.
Le rôle d'un Garant consiste principalement à participer au processus de signalement et de confirmation du décès.
La désignation comme Garant :
• ne rend pas le Garant propriétaire des données ;
• ne fait pas du Garant un héritier ;
• ne fait pas du Garant un ayant droit ;
• ne lui permet pas de modifier les volontés de l'utilisateur ;
• ne lui permet pas d'accéder librement aux messages destinés à d'autres personnes.`,
  },
  {
    t: "ARTICLE 19 — SIGNALEMENT DU DÉCÈS",
    p: `Après le décès d'un utilisateur Postinity, un ou plusieurs Garants peuvent être amenés à signaler ou confirmer ce décès.
Une simple déclaration ne provoque pas nécessairement la transmission immédiate des contenus.
Un processus de contrôle peut être déclenché avant toute publication ou transmission.`,
  },
  {
    t: "ARTICLE 20 — VÉRIFICATION DU DÉCÈS",
    p: `La Plateforme peut notamment demander :
• la confirmation d'un ou plusieurs Garants ;
• un justificatif officiel ;
• un acte ou certificat relatif au décès lorsque cela est approprié ;
• des informations d'identité ;
• tout élément raisonnablement nécessaire pour éliminer un doute.
ECO EVENT SARL peut suspendre le processus aussi longtemps qu'un doute sérieux subsiste.`,
  },
  {
    t: "ARTICLE 21 — FAUSSE DÉCLARATION DE DÉCÈS",
    p: `Toute fausse déclaration volontaire de décès est strictement interdite.
Une personne effectuant sciemment une fausse déclaration engage sa propre responsabilité.
ECO EVENT SARL pourra notamment :
• interrompre immédiatement la procédure ;
• bloquer les accès concernés ;
• suspendre un compte ;
• conserver les éléments légalement nécessaires à l'établissement des faits ;
• coopérer avec les autorités compétentes ;
• entreprendre toute démarche appropriée.`,
  },
  {
    t: "ARTICLE 22 — MESSAGES POSTHUMES",
    p: `Après vérification du décès et lorsque les conditions prévues sont réunies, Postinity peut transmettre les messages préparés par l'utilisateur aux destinataires désignés.
Cette transmission peut intervenir notamment :
• par courrier électronique ;
• par lien sécurisé ;
• par code d'accès ;
• par espace sécurisé.
Le destinataire peut être amené à confirmer son identité ou à utiliser un dispositif d'authentification avant l'accès au contenu.`,
  },
  {
    t: "ARTICLE 23 — ABSENCE DE GARANTIE DE REMISE",
    p: `ECO EVENT SARL met en œuvre les moyens raisonnables prévus par le service afin de transmettre les contenus concernés.
Toutefois, la remise effective ne peut être garantie notamment lorsque :
• les coordonnées fournies sont erronées ;
• l'adresse électronique n'existe plus ;
• le destinataire est introuvable ;
• le message est bloqué par un système anti-spam ;
• le destinataire refuse de consulter le contenu ;
• le destinataire est décédé ;
• un litige empêche temporairement la transmission ;
• une obligation légale empêche la transmission ;
• une impossibilité technique indépendante de la Plateforme intervient.`,
  },
  {
    t: "ARTICLE 24 — DROITS DU DESTINATAIRE",
    p: `Une personne désignée comme destinataire d'un message Postinity n'est jamais obligée de consulter ou d'accepter ce message.
Elle peut refuser d'accéder au contenu.
Elle peut également exercer les droits dont elle dispose sur ses propres données personnelles.`,
  },
  {
    t: "ARTICLE 25 — DOSSIER DE CÉRÉMONIE",
    p: `Postinity peut permettre à un utilisateur de préparer un dossier destiné à faciliter ultérieurement l'organisation d'un hommage ou d'une cérémonie.
Il peut comprendre notamment :
• photographies ;
• vidéos ;
• diaporamas ;
• musiques ;
• textes ;
• citations ;
• documents.
Postinity agit comme plateforme numérique de conservation et de transmission.
La mise en ligne d'une volonté sur Postinity ne lui confère pas automatiquement une valeur testamentaire ou juridique particulière.`,
  },
  {
    t: "ARTICLE 26 — DURÉE DE CONSERVATION",
    p: `Les contenus sont conservés pendant la durée associée au service ou à l'offre choisie, sous réserve :
• des obligations légales ;
• des sauvegardes techniques ;
• des droits des tiers ;
• des instructions valablement enregistrées ;
• des nécessités probatoires en cas de litige.
Les règles détaillées de conservation des données personnelles sont précisées dans la Politique de confidentialité.`,
  },
  {
    t: "ARTICLE 27 — OFFRES BOUGIEDUCŒUR",
    p: `La Plateforme peut proposer différentes offres, gratuites ou payantes, notamment :
• bougie gratuite ;
• offre découverte ;
• durée mensuelle ;
• durée prolongée ;
• bougie éternelle ;
• offre de lancement ;
• prolongation ;
• avantages promotionnels ;
• avantages Ambassadeur ;
• avantages de parrainage.
Les caractéristiques de chaque offre sont indiquées avant la validation.`,
  },
  {
    t: "ARTICLE 28 — NOTION DE « BOUGIE ÉTERNELLE »",
    p: `L'expression commerciale « bougie éternelle » désigne une bougie ne comportant pas d'échéance contractuelle prédéterminée pendant la durée normale d'exploitation du service.
Elle ne constitue pas une promesse d'existence infinie du site ou de la société exploitante.
En cas de cessation définitive du service, ECO EVENT SARL fera ses meilleurs efforts pour informer les utilisateurs concernés et, lorsque cela est techniquement possible, permettre la récupération de leurs principaux contenus.`,
  },
  {
    t: "ARTICLE 29 — SERVICES PAYANTS POSTINITY",
    p: `Certains services Postinity peuvent être payants, notamment :
• accès ou déblocage de certains dossiers ;
• crédits de messages ;
• packs ;
• options particulières ;
• services complémentaires.
Les conditions et le prix sont affichés avant validation de l'achat.`,
  },
  {
    t: "ARTICLE 30 — PRIX",
    p: `Les prix applicables sont ceux affichés au moment de la commande.
Ils sont présentés dans la devise applicable et taxes comprises lorsque la réglementation l'exige.
La Plateforme peut proposer temporairement :
• promotions ;
• réductions ;
• codes promotionnels ;
• bonus ;
• offres spéciales ;
• packs.`,
  },
  {
    t: "ARTICLE 31 — PAIEMENT",
    p: `Les paiements sont réalisés par l'intermédiaire d'un centre ou prestataire de paiement par carte bancaire sécurisé.
ECO EVENT SARL ne conserve pas directement les numéros complets des cartes bancaires.
Plusieurs prestataires de paiement peuvent être utilisés selon :
• la disponibilité technique ;
• le pays ;
• la devise ;
• le type de transaction.`,
  },
  {
    t: "ARTICLE 32 — DROIT DE RÉTRACTATION",
    p: `Lorsque le droit de rétractation prévu par le Code de la consommation est applicable, le consommateur bénéficie des droits correspondants.
Lorsque l'utilisateur demande la fourniture immédiate d'un contenu ou service numérique avant l'expiration du délai légal, la Plateforme recueille, lorsque cela est nécessaire :
• son accord exprès pour le commencement immédiat de l'exécution ;
• sa reconnaissance expresse de la perte de son droit de rétractation lorsque les conditions légales sont réunies.
La perte du droit de rétractation n'est donc pas présumée du seul fait de l'achat ou de l'allumage d'une bougie.`,
  },
  {
    t: "ARTICLE 33 — REMBOURSEMENTS",
    p: `Les remboursements éventuels sont examinés en fonction :
• du service concerné ;
• de son état d'exécution ;
• des dispositions légales impératives ;
• des circonstances particulières.
Un avantage promotionnel, une bougie offerte, un bonus, un mois gratuit ou un crédit offert ne donne pas lieu à remboursement en espèces.`,
  },
  {
    t: "ARTICLE 34 — PARRAINAGE",
    p: `La Plateforme peut proposer un programme de parrainage.
L'utilisateur peut disposer d'un lien personnel lui permettant d'inviter des proches.
Des avantages peuvent être accordés lorsque les conditions du programme sont remplies.
Toute utilisation artificielle ou frauduleuse du système peut entraîner l'annulation des avantages.`,
  },
  {
    t: "ARTICLE 35 — PROGRAMME AMBASSADEUR",
    p: `Certaines personnes peuvent bénéficier du statut d'Ambassadeur BougieDuCœur.
Le programme peut notamment permettre l'attribution :
• de bougies gratuites ;
• de bougies éternelles ;
• d'un code ;
• d'un lien personnel ;
• d'avantages spécifiques.
Les conditions du programme peuvent évoluer.
Un Ambassadeur peut demander sa désinscription.`,
  },
  {
    t: "ARTICLE 36 — PROPRIÉTÉ INTELLECTUELLE",
    p: `Les noms, signes distinctifs, interfaces et créations associés à la Plateforme sont protégés par les règles applicables en matière de propriété intellectuelle.
Sont notamment concernés :
• BougieDuCœur ;
• Postinity ;
• leurs dénominations ;
• leurs marques ;
• leurs logos ;
• leurs signes distinctifs ;
• leurs identités visuelles ;
• leurs chartes graphiques ;
• leurs interfaces ;
• leurs illustrations ;
• leurs créations graphiques ;
• leurs textes éditoriaux ;
• leurs bases de données ;
• leurs développements logiciels ;
• leurs éléments fonctionnels et visuels originaux.
Les marques, dénominations et droits de propriété intellectuelle associés à BougieDuCœur et Postinity sont la propriété d'une ou plusieurs personnes physiques titulaires des droits correspondants.
L'identité, ainsi que le nombre exact de cette ou de ces personnes physiques, n'a pas vocation à être rendu public sur la Plateforme.
ECO EVENT SARL bénéficie des droits et autorisations nécessaires lui permettant d'exploiter, utiliser, développer, administrer, promouvoir et commercialiser les marques BougieDuCœur et Postinity, ainsi que les sites, applications et services qui leur sont associés.
L'exploitation de ces marques par ECO EVENT SARL n'emporte aucun transfert de leur propriété au bénéfice de la société.
Toute reproduction, imitation, représentation, adaptation, extraction, modification, distribution ou exploitation non autorisée, totale ou partielle, est interdite.
Les utilisateurs demeurent propriétaires des droits qu'ils détiennent sur leurs propres contenus.`,
  },
  {
    t: "ARTICLE 37 — DISPONIBILITÉ",
    p: `ECO EVENT SARL met en œuvre des moyens raisonnables afin d'assurer le fonctionnement de la Plateforme.
Des interruptions peuvent néanmoins intervenir, notamment en raison :
• d'une maintenance ;
• d'une mise à jour ;
• d'une correction ;
• d'une intervention de sécurité ;
• d'une panne ;
• d'un problème réseau ;
• d'un prestataire extérieur ;
• d'un événement de force majeure.
Une disponibilité permanente et sans interruption ne peut être garantie.`,
  },
  {
    t: "ARTICLE 38 — SAUVEGARDE ET SÉCURITÉ",
    p: `Des mesures techniques et organisationnelles sont mises en œuvre pour protéger les informations traitées.
La Plateforme peut notamment recourir à :
• chiffrement ;
• contrôle d'accès ;
• sauvegardes ;
• journalisation ;
• authentification ;
• surveillance technique.
Aucun système informatique ne permettant une sécurité absolue, l'utilisateur est invité à conserver une copie personnelle de ses contenus particulièrement importants.`,
  },
  {
    t: "ARTICLE 39 — RESPONSABILITÉ",
    p: `ECO EVENT SARL répond des obligations mises à sa charge par la loi et les contrats conclus avec ses utilisateurs.
Sa responsabilité ne pourra toutefois être engagée pour un dommage exclusivement imputable :
• à l'utilisateur ;
• à un tiers ;
• à une information erronée communiquée à la Plateforme ;
• à une mauvaise adresse de destinataire ;
• à la compromission des identifiants de l'utilisateur ;
• à un événement de force majeure ;
• à une circonstance extérieure imprévisible et insurmontable.
Aucune disposition des présentes CGU ne limite les droits impératifs reconnus aux consommateurs.`,
  },
  {
    t: "ARTICLE 40 — DONNÉES PERSONNELLES",
    p: `ECO EVENT SARL est responsable des traitements mis en œuvre dans le cadre des services dont elle détermine les finalités et les moyens.
Les données traitées peuvent notamment comprendre :
• identité ;
• coordonnées ;
• e-mail ;
• téléphone ;
• pays ;
• langue ;
• photographie de profil ;
• données de compte ;
• contenus déposés ;
• relations avec les Garants et destinataires ;
• messages ;
• historiques ;
• données de connexion ;
• informations techniques ;
• données liées aux paiements ;
• données de parrainage ;
• préférences de communication.
Les traitements sont détaillés dans la Politique de confidentialité.`,
  },
  {
    t: "ARTICLE 41 — DROITS DES PERSONNES",
    p: `Dans les conditions prévues par la réglementation applicable, les personnes concernées peuvent exercer notamment leurs droits :
• d'accès ;
• de rectification ;
• d'effacement ;
• de limitation ;
• d'opposition ;
• de portabilité lorsque celle-ci est applicable ;
• de retrait du consentement pour les traitements fondés sur celui-ci.
Les demandes peuvent être adressées à : contact@bougieducoeur.com
Une vérification raisonnable de l'identité du demandeur peut être réalisée lorsque cela est nécessaire.
Toute personne dispose également du droit de saisir la CNIL.`,
  },
  {
    t: "ARTICLE 42 — DONNÉES APRÈS LE DÉCÈS",
    p: `Une personne peut définir de son vivant des directives concernant la conservation, l'effacement ou la communication de ses données personnelles après son décès.
Les directives particulières concernant Postinity sont recueillies par un mécanisme spécifique et distinct de la seule acceptation des présentes CGU.
Les informations comportant également des données personnelles relatives à des tiers demeurent soumises aux droits de ces personnes.`,
  },
  {
    t: "ARTICLE 43 — COOKIES ET TRACEURS",
    p: `La Plateforme peut utiliser des technologies nécessaires :
• à l'authentification ;
• à la sécurité ;
• au fonctionnement ;
• à la mémorisation des préférences.
D'autres traceurs peuvent notamment concerner :
• la mesure d'audience ;
• les réseaux sociaux ;
• les statistiques ;
• certaines fonctionnalités externes.
Lorsque le consentement est requis, ces technologies ne sont utilisées qu'après le choix de l'utilisateur.`,
  },
  {
    t: "ARTICLE 44 — COMMUNICATIONS",
    p: `La Plateforme peut envoyer des communications nécessaires au fonctionnement du service, notamment :
• confirmation de compte ;
• invitation ;
• sécurité ;
• Garants ;
• rappels ;
• transmission Postinity ;
• paiements ;
• opérations relatives au compte.
Les communications commerciales sont distinctes.
Lorsqu'un consentement est nécessaire, l'utilisateur dispose d'un mécanisme lui permettant de s'y opposer ou de se désinscrire.`,
  },
  {
    t: "ARTICLE 45 — PRESTATAIRES",
    p: `ECO EVENT SARL peut recourir à des prestataires pour assurer notamment :
• hébergement ;
• stockage ;
• paiements ;
• e-mails ;
• sécurité ;
• statistiques ;
• infrastructure informatique ;
• authentification ;
• services techniques.
Les catégories ou identités des prestataires et les éventuels transferts internationaux sont précisés dans la Politique de confidentialité lorsque la réglementation l'exige.`,
  },
  {
    t: "ARTICLE 46 — INTELLIGENCE ARTIFICIELLE",
    p: `La Plateforme peut utiliser des outils d'intelligence artificielle pour assister l'administration, notamment dans la préparation de contenus éditoriaux.
Une intervention humaine demeure mise en œuvre lorsque la nature de la décision ou la réglementation applicable l'exige.
La validation d'un décès et le déclenchement d'une transmission posthume ne doivent pas reposer exclusivement sur un mécanisme automatisé lorsque les circonstances exigent une vérification humaine.`,
  },
  {
    t: "ARTICLE 47 — SUPPRESSION DU COMPTE",
    p: `L'utilisateur peut demander la suppression de son compte selon les fonctionnalités disponibles ou à : contact@bougieducoeur.com
La suppression peut entraîner :
• fermeture du compte ;
• suppression de contenus ;
• anonymisation de certaines données ;
• arrêt de certains services.
Des données peuvent néanmoins être conservées lorsque cela est nécessaire pour :
• une obligation légale ;
• une preuve de transaction ;
• la prévention de la fraude ;
• un litige ;
• la défense des droits de la Plateforme ou d'un tiers.
L'utilisateur Postinity doit avoir conscience que la suppression de contenus avant son décès peut rendre leur transmission future impossible.`,
  },
  {
    t: "ARTICLE 48 — SUSPENSION ET FERMETURE",
    p: `Un compte peut être suspendu ou fermé notamment en cas :
• de fraude ;
• de fausse identité ;
• de fausse déclaration de décès ;
• de tentative de piratage ;
• de contenus manifestement illicites ;
• d'utilisation abusive ;
• de fraude aux paiements ;
• de fraude au parrainage ;
• de violation grave ou répétée des présentes CGU.
Lorsque les circonstances le permettent, l'utilisateur est informé de la mesure.`,
  },
  {
    t: "ARTICLE 49 — ÉVOLUTION DU SERVICE",
    p: `BougieDuCœur et Postinity sont susceptibles d'évoluer.
De nouvelles fonctionnalités peuvent être ajoutées et certaines fonctionnalités existantes adaptées.
Une modification substantielle des droits ou obligations des utilisateurs donne lieu à une information appropriée.`,
  },
  {
    t: "ARTICLE 50 — MODIFICATION DES CGU",
    p: `Les présentes CGU peuvent évoluer notamment pour tenir compte :
• des nouvelles fonctionnalités ;
• de l'évolution de la réglementation ;
• d'une évolution technique ;
• de nouvelles offres ;
• de modifications de sécurité.
Lorsque cela est nécessaire, les utilisateurs sont informés d'une modification substantielle.`,
  },
  {
    t: "ARTICLE 51 — RÉCLAMATIONS",
    p: `Toute réclamation peut être adressée à :
BougieDuCœur / Postinity
ECO EVENT SARL
78 avenue des Champs-Élysées
75008 Paris
France
E-mail : contact@bougieducoeur.com
Une résolution amiable est recherchée en priorité.`,
  },
  {
    t: "ARTICLE 52 — MÉDIATION DE LA CONSOMMATION",
    p: `Lorsque les conditions légales sont réunies, un consommateur ayant préalablement présenté une réclamation écrite peut recourir gratuitement au médiateur de la consommation dont relève ECO EVENT SARL.
Médiateur désigné : à compléter après adhésion effective à un médiateur de la consommation compétent et référencé.
Les coordonnées complètes du médiateur devront être publiées après cette adhésion.`,
  },
  {
    t: "ARTICLE 53 — DROIT APPLICABLE",
    p: `Les présentes CGU sont soumises au droit français.
Pour un consommateur résidant dans un autre État, cette disposition ne le prive pas des règles impératives de protection dont il pourrait bénéficier dans son pays de résidence lorsque celles-ci sont applicables.`,
  },
  {
    t: "ARTICLE 54 — LITIGES",
    p: `En cas de difficulté, les parties recherchent prioritairement une résolution amiable.
À défaut, les juridictions compétentes sont déterminées selon les règles légales applicables.
Aucune disposition des présentes CGU n'a pour objet d'imposer à un consommateur une juridiction qui ne pourrait légalement lui être imposée.`,
  },
  {
    t: "ARTICLE 55 — LANGUES",
    p: `BougieDuCœur et Postinity peuvent être proposés en plusieurs langues.
Les présentes CGU peuvent être traduites afin de faciliter leur compréhension.
Sous réserve des règles impératives applicables au consommateur, la version française constitue la version de référence en cas de divergence d'interprétation.`,
  },
  {
    t: "ARTICLE 56 — CONTACT",
    p: `Pour toute question relative aux présentes CGU :
BOUGIEDUCŒUR / POSTINITY
ECO EVENT SARL
78 avenue des Champs-Élysées
75008 Paris
France
contact@bougieducoeur.com`,
  },
];


export const CGU_FR = {
  title: CGU_TITLE,
  subtitle: CGU_SUBTITLE,
  footer: CGU_FOOTER,
  intro: CGU_INTRO,
  articles: CGU_ARTICLES,
};

// Retourne les CGU dans la langue demandee, avec repli sur le francais.
export function getCgu(lang) {
  let l = (lang || "fr").toLowerCase().split("-")[0];
  if (l === "fr") return CGU_FR;
  if (l === "mx") l = "es";
  const tr = CGU_TR[l];
  if (!tr || !Array.isArray(tr.articles) || tr.articles.length === 0) return CGU_FR;
  return {
    title: tr.title || CGU_TITLE,
    subtitle: CGU_SUBTITLE,
    footer: tr.footer || CGU_FOOTER,
    intro: tr.intro || CGU_INTRO,
    articles: tr.articles,
  };
}
